export default __webpack_public_path__ + "static/media/answers-update.980febbd.png";